// import { Outlet, useNavigate } from 'react-router-dom'
// import { useState, React, useEffect } from 'react'
// import { Menu } from 'semantic-ui-react'
// import Footer from './Footer'
// import '../components/NavMenu.css'

// const NavMenu = () => {
//     const menuArr = ['Analytics', 'Routed', 'FetchGoatNow', 'Logs', 'Preferences', 'Reports', 'Support', 'Tracking', 'RouteStopTemplates', 'Search', 'DriverSync']
//     var index = menuArr.indexOf('RouteStopTemplates');
//     // localStorage.setItem("courierId", null);
//     if (index !== -1) {
//         localStorage.courierId === "null" && menuArr.splice(index, 1)
//         var index2 = menuArr.indexOf('DriverSync');
//         if (index2 !== -1) {
//             localStorage.courierId === "null" && menuArr.splice(index2, 1)
//         }
//         // console.log(localStorage)
//         // localStorage.setItem("courierId", 30027);
//         // localStorage.setItem("courierId", 30037);
//     }
//     const [activeItem, setActiveItem] = useState(localStorage.getItem("route"))
//     const navigate = useNavigate();


//     const handleItemClick = (e, { name }) => {
//         let selectedMenuItem = name;
//         if (selectedMenuItem.includes('Dashboard')) {
//             var extension = "/Routed";
//             selectedMenuItem = selectedMenuItem.concat(extension.toString())
//         }

//         localStorage.setItem("route", selectedMenuItem);

//         navigate(`/${selectedMenuItem}`)
//         selectedMenuItem.includes("Dashboard") ? setActiveItem("Dashboard") : setActiveItem(selectedMenuItem);
//     }

//     useEffect(() => {
//         const loggedInUser = localStorage.getItem("authenticated");
//         if (JSON.parse(loggedInUser) === false) {
//             navigate('/')
//         }
//         setActiveItem(localStorage.route)

//     }, [navigate]);


//     const handleLogout = () => {
//         localStorage.setItem("authenticated", false);
//         localStorage.removeItem("token");
//         localStorage.removeItem("courierId");
//         navigate("/");
//     }

//     return (
//         <>
//             <div className='background'>
//                 <div className='header-container'>
//                     <div className='header' >
//                         <img src="/images/headerForLogin.jpg" alt="header" style={{ width: "100%" }} />
//                     </div>
//                     <Menu pointing inverted className="navMenu">
//                         {menuArr.map((title, id) => {
//                             return (
//                                 <Menu.Item
//                                     key={id}
//                                     name={title}
//                                     active={activeItem === title.replace(/\s/g, '')}
//                                     onClick={handleItemClick}
//                                     className="navMenuItem"
//                                 />
//                             )
//                         })}

//                         <Menu.Menu position='right'>
//                             <Menu.Item
//                                 name='Log Out'
//                                 active={activeItem === 'Log Out'}
//                                 onClick={() => handleLogout('/')}
//                             />
//                         </Menu.Menu>
//                     </Menu>
//                 </div>

//                 <Outlet />
//                 <Footer />
//             </div>
//         </>
//     )
// }

// export default NavMenu

import { NavigateFunction, Outlet, useNavigate } from 'react-router-dom'
import { useState, useEffect } from 'react'
import { Menu } from 'semantic-ui-react'
import { useHybridAuth } from '../auth/HybridAuthContext';
import Footer from './Footer'
import '../components/NavMenu.css'

type Props = {}



const NavMenu = (props: Props) => {
    const { logout } = useHybridAuth();

    const menuArr: string[] = ['Analytics', 'Routed', 'FetchGoatNow', 'Logs', 'Preferences', 'Reports', 'Support', 'Tracking', 'RouteStopTemplates', 'Search', 'DriverSync']
    var index: number = menuArr.indexOf('RouteStopTemplates');
    // localStorage.setItem("courierId", null);
    if (index !== -1) {
        localStorage.courierId === "null" && menuArr.splice(index, 1)
        var index2 = menuArr.indexOf('DriverSync');
        if (index2 !== -1) {
            localStorage.courierId === "null" && menuArr.splice(index2, 1)
        }
        // console.log(localStorage)
        // localStorage.setItem("courierId", 30027);
        // localStorage.setItem("courierId", 30037);
    }
    console.log(localStorage)
    const [activeItem, setActiveItem] = useState<string>(localStorage.getItem("route"))
    const navigate: NavigateFunction = useNavigate();


    const handleItemClick = (e: any, { name }: any) => {
        let selectedMenuItem = name;
        if (selectedMenuItem.includes('Dashboard')) {
            var extension: string = "/Routed";
            selectedMenuItem = selectedMenuItem.concat(extension.toString())
        }

        localStorage.setItem("route", selectedMenuItem);

        navigate(`/${selectedMenuItem}`)
        selectedMenuItem.includes("Dashboard") ? setActiveItem("Dashboard") : setActiveItem(selectedMenuItem);
    }

    useEffect(() => {
        const loggedInUser = localStorage.getItem("authenticated");
        if (JSON.parse(loggedInUser) === false) {
            navigate('/')
        }
        setActiveItem(localStorage.route)

    }, [navigate]);


    const handleLogout = () => {
        // localStorage.setItem("authenticated", false);
        localStorage.setItem("authenticated", 'false');
        localStorage.removeItem("token");
        localStorage.removeItem("courierId");
        logout();
        navigate("/");
    }
    return (
        <>
            <div className='background'>
                <div className='header-container'>
                    <div className='header' >
                        <img src="/images/headerForLogin.jpg" alt="header" style={{ width: "100%" }} />
                    </div>
                    <Menu pointing inverted className="navMenu">
                        {menuArr.map((title, id) => {
                            return (
                                <Menu.Item
                                    key={id}
                                    name={title}
                                    active={activeItem === title.replace(/\s/g, '')}
                                    onClick={handleItemClick}
                                    className="navMenuItem"
                                />
                            )
                        })}

                        <Menu.Menu position='right'>
                            <Menu.Item
                                name='Log Out'
                                active={activeItem === 'Log Out'}
                                // onClick={() => handleLogout('/')}
                                onClick={() => handleLogout()}
                            />
                        </Menu.Menu>
                    </Menu>
                </div>

                <Outlet />
                <Footer />
            </div>
        </>
    )
}

export default NavMenu